import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  Base,
  ColorCodes,
  ColorSvg
} from '@vodacom/web-common';

import {
  Icons
} from '../../../constants';

const Container = styled(Base)`
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;

  ${props => props.isChecked
    ? `background-color: ${(props.isEnabled && props.checkedBackgroundColor) || props.inactiveBackgroundColor};`
    : `
        background-color: ${(props.isEnabled && props.uncheckedBackgroundColor) || props.inactiveBackgroundColor};
        box-shadow:inset 0 0 0 2px ${ColorCodes.Grey5};
      `
  }

  ${props => props.isEnabled && 'cursor: pointer;'}
  ${props => props.borderRadius && `border-radius: ${props.borderRadius};`}
  ${props => props.width && `width: ${props.width};`}
  ${props => props.height && `height: ${props.height};`}
`;

export const CheckBox = (props) => (

  <Container
    height={props.height}
    width={props.width}
    borderRadius={props.borderRadius}
    isEnabled={props.isEnabled}
    isChecked={props.isChecked}
    minHeight={props.minHeight}
    minWidth={props.minWidth}
    maxHeight={props.maxHeight}
    maxWidth={props.maxWidth}
    padding={props.padding}
    margin={props.margin}
    checkedBackgroundColor={props.checkedBackgroundColor}
    inactiveBackgroundColor={props.inactiveBackgroundColor}
    uncheckedBackgroundColor={props.uncheckedBackgroundColor}
    onClick={() => props.isEnabled && props?.onClick?.(props.onClickArgs)}>

      {props.isChecked &&

        <ColorSvg
          src={Icons.Checkmark}
          height={props.iconHeight || `calc(${props.height} / 2)`}
          width={props.iconWidth || `calc(${props.width} / 2)`}
          color={(props.isEnabled && props.checkedIconColor) || props.inactiveIconColor}
        />
      }
  </Container>
);

CheckBox.propTypes = {
  ...Base.propTypes,
  isEnabled: PropTypes.bool,
  isChecked: PropTypes.bool,
  height: PropTypes.string,
  width: PropTypes.string,
  borderRadius: PropTypes.string,
  iconHeight: PropTypes.string,
  iconWidth: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onClickArgs: PropTypes.any,
  checkedBackgroundColor: PropTypes.string,
  inactiveBackgroundColor: PropTypes.string,
  uncheckedBackgroundColor: PropTypes.string,
  checkedIconColor: PropTypes.string,
  inactiveIconColor: PropTypes.string
};

CheckBox.defaultProps = {
  ...Base.defaultProps,
  isEnabled: true,
  isChecked: false,
  height: '10vmin',
  width: '10vmin',
  borderRadius: '1vmin',
  iconHeight: undefined,
  iconWidth: undefined,
  onClick: () => { },
  onClickArgs: null,
  checkedBackgroundColor: ColorCodes.Red2,
  inactiveBackgroundColor: ColorCodes.Grey5,
  uncheckedBackgroundColor: ColorCodes.White,
  checkedIconColor: ColorCodes.White,
  inactiveIconColor: ColorCodes.Grey6
};
